export default __webpack_public_path__ + "static/media/PostCodeBlack.4abe84fe.svg";